import { render, staticRenderFns } from "./Discovery.vue?vue&type=template&id=378c9f6a&"
import script from "./Discovery.vue?vue&type=script&lang=js&"
export * from "./Discovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports